import script from "./BarcodeScannerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BarcodeScannerModal.vue?vue&type=script&setup=true&lang=js"

import "./BarcodeScannerModal.vue?vue&type=style&index=0&id=736f6450&lang=css"

const __exports__ = script;

export default __exports__